const SESSION_ID = "LOGGED_IN";

const saveSession = (key, value) => {
  localStorage.setItem(key, value);
};

const getSessionItem = (key) => {
  return JSON.parse(localStorage.getItem(key));
};

const deleteSession = (key) => {
  localStorage.removeItem(key);
};

export const startSession = (value) => {
  saveSession(SESSION_ID, value);
};

export const getSession = () => getSessionItem(SESSION_ID);
export const destroySession = () => {
  deleteSession(SESSION_ID);
  try {
    localStorage.removeItem("settings_selected_tab");
    localStorage.removeItem("admin_selected_location");
    localStorage.removeItem("admin_selected_sport");
    localStorage.removeItem("activity_log_page");
    localStorage.removeItem("activity_log_rows_per_page");
  } catch {}
};

export const loggedIn = () => (getSession() ? true : false);

export const getName = () => {
  const session = getSession();
  return session &&
    session.userData &&
    session.userData.user &&
    session.userData.user.first_name
    ? session.userData.user.first_name
    : "";
};

export const getRole = () => {
  const session = getSession();
  return session &&
    session.userData &&
    session.userData.user &&
    session.userData.user.roles
    ? session.userData.user.roles
    : [];
};

export const getLocations = () => {
  const session = getSession();
  // First try to get from userData
  if (
    session &&
    session.userData &&
    session.userData.user &&
    session.userData.user.locations
  ) {
    return session.userData.user.locations;
  }

  // If not in userData, try to decode from JWT token
  if (session && session.access_token) {
    const decoded = decodeJwt(session.access_token);
    if (decoded && decoded.user && decoded.user.locations) {
      return decoded.user.locations;
    }
  }

  return [];
};

export const getUser = () => {
  const session = getSession();
  if (session && session.userData && session.userData.user) {
    // Ensure locations are included from JWT token if not in userData
    const user = { ...session.userData.user };
    if (!user.locations) {
      user.locations = getLocations();
    }
    return user;
  }
  return {};
};

export const getAccessToken = () =>
  getSession() ? getSession().access_token : "";

export const getRefreshToken = () =>
  getSession() ? getSession().refresh_token : "";

export const setTokens = ({ access_token, refresh_token }) => {
  const session = getSession() || {};
  const updated = {
    ...session,
    ...(access_token ? { access_token } : {}),
    ...(refresh_token ? { refresh_token } : {}),
  };
  saveSession(SESSION_ID, JSON.stringify(updated));
};

export const updateUser = (value) => {
  const updatedSession = {
    ...getSession(),
    userData: {
      user: { ...value, roles: getRole(), locations: getLocations() },
    },
  };
  saveSession(SESSION_ID, JSON.stringify(updatedSession));
};

export const isAuthorized = (role) => {
  const roles = getRole();

  // Handle both string and array formats, and case sensitivity
  if (!roles || !Array.isArray(roles)) {
    return false;
  }

  const is_allowed = roles.some((r) => {
    const match = r === role || r.toUpperCase() === role.toUpperCase();

    return match;
  });

  return is_allowed;
};

// Add JWT decode helper
function decodeJwt(token) {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
    return JSON.parse(jsonPayload);
  } catch {
    return null;
  }
}

export function isTokenExpired() {
  const session = getSession();
  if (!session || !session.access_token) return true;
  const decoded = decodeJwt(session.access_token);
  if (!decoded || !decoded.exp) return true;
  // exp is in seconds since epoch
  const now = Math.floor(Date.now() / 1000);
  return decoded.exp < now;
}

export function isTokenExpiringSoon(seconds = 300) {
  const session = getSession();
  if (!session || !session.access_token) return true;
  const decoded = decodeJwt(session.access_token);
  if (!decoded || !decoded.exp) return true;
  const nowMs = Date.now();
  const expMs = decoded.exp * 1000;
  return nowMs >= expMs - seconds * 1000;
}
